import React from "react"
import ShowCase from "../components/Showcase"
import { DatePicker, View, Text } from "react-ame-components"

export class DatePickerExample extends React.Component {
  state = {
    date: null,
    minDate: null,
    maxDate: null,
    textDate: null,
    hint: "",
    error: false,
  }

  getMinDate = value => {
    value &&
      this.setState({
        minDate: value,
      })
  }

  getMaxDate = value => {
    value &&
      this.setState({
        maxDate: value,
      })
  }

  onDateChange = value => {
    value &&
      this.setState({
        date: value,
        textDate: value?.toLocaleDateString("pt-br"),
      })

    if (
      value?.toLocaleDateString("pt-br") !=
      new Date(1993, 10, 5)?.toLocaleDateString("pt-br")
    ) {
      this.setState({
        hint: "Esse não é meu aniversário!",
        error: true,
      })
    } else {
      this.setState({
        hint: "Esse é meu aniversário!",
        error: false,
      })
    }
  }

  render() {
    return (
      <ShowCase
        centerGrid
        title="Componente DatePicker"
        description="Componente para entrada datas, podendo ser escrita no input ou selecionada no calendário">
        <View flexWrap="wrap">
          <View
            width="350px"
            padding="small">
            <DatePicker
              value={this.state.minDate}
              onChange={e => this.getMinDate(e)}
              placeholder="Escolha uma data mínima"
            />
          </View>
          <View
            width="350px"
            padding="small">
            <DatePicker
              value={this.state.maxDate}
              onChange={e => this.getMaxDate(e)}
              placeholder="Escolha uma data máxima"
            />
          </View>
          <View
            width="350px"
            padding="small">
            <DatePicker
              value={this.state.date}
              onChange={e => this.onDateChange(e)}
              placeholder="Data de Nascimento"
              minDate={this.state.minDate}
              maxDate={this.state.maxDate}
              hint={this.state.hint}
              error={this.state.error}
              dataCy="date-picker-cypress"
            />
          </View>
        </View>

        <View paddingTop="small">
          <Text dataCy="date-value">
            O valor digitado foi de: {this.state.textDate}
          </Text>
        </View>
      </ShowCase>
    )
  }
}
